export { default } from './svg/align-right.svg';
